<template >
  <div class="wrapper">
    <parallax
        class="section page-header header-filter"
        :style="headerStyle"
    ></parallax>
    <div class="main main-raised" style="background-color: ivory">
      <div class="section profile-content">
        <div class="container">
          <div class="profile-tabs text-center mb-5">
            <!--прелоадер-->
            <Preloader v-if="this.preloader === true"></Preloader>
            <!--выбор Каталог-->
            <InputSelectCatalog @getCatalogId="getColor($event)"></InputSelectCatalog>
            <!--выбор цвета-->
            <InputSelectColor v-if="catalog_id" @getColor="getProduct($event)"></InputSelectColor>
            <!--комент к цвету-->
<!--            <h4 v-if="(color_info && color_info[3] !== null)" class="desc-color">
              <span >{{ color_info[3] }}</span>
            </h4>-->
            <!--просмотр цвета-->
            <ModalShowColor  class="mb-2 mt-2" v-if="color_info &&  color_info[2] !== 'null'" :color_info="color_info"></ModalShowColor>
            <!--выбор продукт-->
            <InputSelectProduct v-if="color_info" @getRecipeId="getRecipe($event)"></InputSelectProduct>


            <div v-if="recipe.data && recipe_id">
              <!--комент к рецептуре-->
              <h4 v-if="(recipe.data.comment !== null)" class="desc-color">
                Рекомендован Подклад
                <span >{{ recipe.data.comment }}</span>
              </h4>
              <!--Показ типа продукта-->
              <div  class="mt-2 type-base text-center " style="right: 10px" @click="showProfit =!showProfit">
                <strong> {{ recipe.data.base.name }}</strong>
              </div>
              <!--Показ выбора весов-->
              <RadioSelectWeight  @get_weight = "getWeight($event)" :buttonDisabled="this.buttonDisabled"
                :weights="recipe.data.weights" :selectWeight = "selectedWeight"></RadioSelectWeight>
              <!--количество банок-->
              <div v-if="selectedWeight !== 0">
              <b-input-group class="count-style m-2 " prepend="Количество" >
                <b-form-input :disabled="this.buttonDisabled" type="number" v-model="countProduct" :value="countProduct"></b-form-input>
              </b-input-group>
              <!--цена колеровки-->
                <Price :count = "countProduct" :price="(colorant_price)" :title="'Цена колеровки:'"></Price>
                <!--Цена продукта-->
                <Price :count = "1" :price="(product_price*countProduct)" :title="'Цена продукта:'"></Price>
                <!--Общая стоимость-->
                <Price :count = "countProduct" :price="(product_price+colorant_price)" :title="'Итого:'"></Price>
                <div v-if="showProfit">
                <Price :count = "countProduct" :price="(profit_colorant*countProduct)" :title="'Прибыль с колорантов:'" :color="'background: #cb7e13'"></Price>
                <Price :count = "countProduct" :price="(profit_product)" :title="'Прибыль с продуктов:'" :color="'background: #cb7e13'"></Price>
                </div>
              <!--Блок с рецептурами-->
              <RecipeSection v-if="role === '3' && selectedWeight !== 0"
                             :color_name ="color_info[1]"
                             :weight = "selectedWeight"
                             @buttonDisabled="buttonDisabled = true">
              </RecipeSection>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import {mapActions, mapGetters} from "vuex";
import Preloader from "./components/Preloader";
import router from "../router";
import RecipeSection from "./components/tinting/RecipeSection";
import InputSelectCatalog from "./components/tinting/InputSelectCatalog";
import InputSelectColor from "./components/tinting/InputSelectColor";
import ModalShowColor from "./components/tinting/ModalShowColor";
import InputSelectProduct from "./components/tinting/InputSelectProduct";
import RadioSelectWeight from "./components/tinting/RadioSelectWeight";
import Price from "./components/tinting/Price";
export default {
  components: {
    Price,
    RadioSelectWeight,
    InputSelectProduct,
    ModalShowColor,
    InputSelectColor,
    InputSelectCatalog,
    RecipeSection,
    Preloader,
  },
  bodyClass: "profile-page",
  name: 'Color',
  data() {
    return {
      role: localStorage.getItem('role'),
      catalog_id: null,
      color_info: null,
      recipe_id: null,
      selectedWeight: 0,
      countProduct:1,
      buttonDisabled: true,
      colorant_price: 0,
      product_price: 0,
      profit_colorant: 0,
      profit_product: 0,
      valueColorants: null,
      showProfit: false,
    }
  },
  props: {

    header: {
      type: String,
      default: require("@/assets/img/city-profile.jpg")
    },


  },
  computed: {
    ...mapGetters(['catalog','color','product','recipe','preloader','sendError']),

    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    },

  },

  methods: {
    ...mapActions(['loadCatalogs','loadColors','loadProducts','loadRecipe']),

    clearInput(){
      this.selectedWeight = 0;
      this.countProduct = 1;
      this.buttonDisabled = false;
    },

    getColor(event){
      this.color_info = null;
      this.recipe_id = null;
      this.product_price = 0;
      this.clearInput();
      this.catalog_id = event;
      this.loadColors(this.catalog_id);

    },
    getProduct(event){
      this.recipe_id = null;
      this.product_price = 0;
      this.clearInput();
      this.color_info = event[0];
      this.loadProducts(this.color_info[0])

    },
    getRecipe(event) {
      this.product_price = 0;
      this.clearInput();
      this.recipe_id = event;
      this.loadRecipe(this.recipe_id);
    },

    getSumColorant() {
      let desc = this.recipe.data.product.product_desc;
      let buy = null;
      let sell = null;
      let val;
      let price = 0;
      let price_sell = 0;
      let colorantSystem = this.recipe.data.colorant_system;


      let recipe = this.recipe.data.new_recipe_colorants;

      //////////после смены колорантов удалить if блок//
      if (colorantSystem === 'old'){
        recipe = this.recipe.data.old_recipe_colorants;
      }
      recipe.forEach(element => {
        buy = element.colorant.data_colorant.purchase_price;
        sell = element.colorant.data_colorant.selling_price;
        val = element.value;
        price =  (price +(sell - buy)/1000 * val);
        price_sell = (price_sell + (sell/1000 * val));
      });

      this.colorant_price = price_sell * this.selectedWeight / desc;
      this.profit_colorant = price * this.selectedWeight/ desc;
    },

    getSumProduct() {
      let buy = null;
      let sell = null;
      let price = 0;
      let price_sell = 0;
      let weight_id = 0;

      this.recipe.data.weights.forEach(element => {
        if (this.selectedWeight === element.value){
          weight_id = element.id;
        }
      });

      this.recipe.data.price_product.forEach(element => {
        if (weight_id === element.product_weight_id){
          buy = element.purchase_price;
          sell = element.selling_price;
        }
      });

      price = sell - buy;
      price_sell = sell;

      this.product_price = price_sell;
      this.profit_product = price;
    },

    getWeight(event) {
      this.selectedWeight = event;
      this.getSumColorant();
      this.getSumProduct();
    },

  },
  mounted() {
    if (this.catalog.length === 0) {
      this.loadCatalogs();
    }
  },
  updated() {
    if (!localStorage.getItem('token')){
      router.push({ name: "auth"})
    }
  }
  /*beforeUpdate() {
    if (this.recipe.length !== 0 && this.recRecount.length === 0) {
      this.recipe.data.old_recipe_colorants.forEach(element => this.recountRecipe(element.colorant.name, element.value))
    }
  }*/
};

</script>

<style lang="scss" scoped>
.section {
  padding: 0;
}

.profile-tabs::v-deep {
  .md-card-tabs .md-list {
    justify-content: center;
  }

  [class*="tab-pane-"] {
    margin-top: 3.213rem;
    padding-bottom: 50px;

    img {
      margin-bottom: 2.142rem;
    }
  }
}
.select-custom {
  background-color: antiquewhite;
}

.form-select-lg {
  width: 90%;

}
.count-style {
  width: 200px !important;
}
.type-base {
    background-color: #f5f5c6;
    border-radius: 50%;
    width: min-content;
    padding: 15px;
    position: absolute;
    color: #077790;
    font-weight: bold;
  font-family: 'Lato', sans-serif;
  -webkit-box-shadow: -17px 10px 29px 4px rgba(34, 60, 80, 0.45);
  -moz-box-shadow: -17px 10px 29px 4px rgba(34, 60, 80, 0.45);
  box-shadow: -17px 10px 29px 4px rgba(34, 60, 80, 0.45);
}
.desc-color {
  background-color: rgb(255,255,255);
  border-radius: 5%;
  font-family: -apple-system;
}
.desc-color span {
  color: orangered;
  font-size: 20px;
}


</style>
